import {
  // useMutation,
  useQuery,
  // useQueryClient
} from "@tanstack/react-query";
import {
  getProductsApi,
  getProductDetailsApi,
  getProductByCategoryApi,
  getCategoriesApi,
  getCategoriesHierachyApi,
  getOrdersApi,
  getOrdersByIDApi,
  getLocationsApi,
  getStoresLocationsApi,
  getBrandsApi,
  getbannersApi,
  approvedPrescriptions,
} from "../services/products";

export const getProductsQuery = (parameters) => ({
  queryKey: ["products", parameters],
  queryFn: async () => {
    const response = await getProductsApi(parameters);
    return response;
  },
  staleTime: 1000 * 60 * 5,
});

export const useGetProductsPrefetch = (parameters) => {
  return useQuery(getProductsQuery(parameters));
};

export const useGetProducts = (parameters) => {
  const { isPending, isError, data, error } = useQuery({
    queryKey: ["products", parameters],
    queryFn: async () => {
      const response = await getProductsApi(parameters);
      return response;
    },
  });

  return { isPending, isError, data, error };
};

export const useGetProductsSearchQuery = (parameters) => {
  const { isPending, isError, data, error } = useQuery({
    queryKey: ["products", parameters],
    queryFn: async () => {
      const response = await getProductsApi(parameters);
      return response;
    },
    enabled: !!parameters.search,
  });

  return { isPending, isError, data, error };
};

export const useGetbrands = (parameters) => {
  const { isPending, isError, data, error } = useQuery({
    queryKey: ["brands", parameters],
    queryFn: async () => {
      const response = await getBrandsApi(parameters);
      return response;
    },
    staleTime: 1000 * 60 * 60, // 1 hour
  });

  return { isPending, isError, data, error };
};

export const useGetBanners = (parameters = {}) => {
  const { isPending, isError, data, error } = useQuery({
    queryKey: ["banners", parameters],
    queryFn: async () => {
      const response = await getbannersApi(parameters);
      return response;
    },
  });

  return { isPending, isError, data, error };
};

export const useGetProductDetails = (id) => {
  const { isPending, isError, data, error } = useQuery({
    queryKey: ["product_details", id],
    queryFn: async () => {
      const response = await getProductDetailsApi(id);
      return response;
    },
    enabled: !!id,
  });

  return { isPending, isError, data, error };
};

export const useGetProductByCategory = (categoryName) => {
  const { isPending, isError, data, error } = useQuery({
    queryKey: ["category_products", categoryName],
    queryFn: async () => {
      const response = await getProductByCategoryApi(categoryName);
      return response;
    },
    enabled: !!categoryName,
  });

  return { isPending, isError, data, error };
};

export const useGetCategories = () => {
  const { isPending, isError, data, error } = useQuery({
    queryKey: ["categories"],
    queryFn: async () => {
      const response = await getCategoriesApi();
      return response;
    },
    staleTime: 1000 * 60 * 60, // 1 hour
  });

  return { isPending, isError, data, error };
};

export const useGetCategorieHierachies = () => {
  const { isPending, isError, data, error } = useQuery({
    queryKey: ["categories_hierachy"],
    queryFn: async () => {
      const response = await getCategoriesHierachyApi();
      return response;
    },
    staleTime: 1000 * 60 * 60, // 1 hour
  });

  return { isPending, isError, data, error };
};

export const useGetOrders = (parameters) => {
  const { isPending, isError, data, error } = useQuery({
    queryKey: ["orders", parameters],
    queryFn: async () => {
      const response = await getOrdersApi(parameters);
      return response;
    },
  });

  return { isPending, isError, data, error };
};

export const useGetOrderDetails = (id) => {
  const { isPending, isError, data, error } = useQuery({
    queryKey: ["order_details", id],
    queryFn: async () => {
      const response = await getOrdersByIDApi(id);
      return response;
    },
    enabled: !!id,
  });

  return { isPending, isError, data, error };
};

export const useGetLocations = ({ latitude, longitude }) => {
  const shouldFetch = latitude && longitude;
  const { isPending, isError, data, error, isSuccess } = useQuery({
    queryKey: ["current_location", latitude, longitude],
    queryFn: async () => {
      const response = await getLocationsApi({ latitude, longitude });
      return response;
    },
    enabled: !!shouldFetch,
    staleTime: 1000 * 60 * 60, // 1 hour
  });

  return { isPending, isError, data, error, isSuccess };
};

export const useGetStoresLocations = ({ userLat, userLng }) => {
  const { isPending, isError, data, error, isSuccess } = useQuery({
    queryKey: ["store_location", userLat, userLng],
    queryFn: async () => {
      const response = await getStoresLocationsApi({ userLat, userLng });
      return response;
    },
  });

  return { isPending, isError, data, error, isSuccess };
};

export const useApprovedPrescriptions = (parameters) => {
  const { isPending, isError, data, error } = useQuery({
    queryKey: ["prescriptions", parameters],
    queryFn: async () => {
      const response = await approvedPrescriptions(parameters);
      return response;
    },
  });

  return { isPending, isError, data, error };
};
